import React from 'react'

import {
  EmailShareButton,
  FacebookShareButton,
  // PinterestShareButton,
  RedditShareButton,
  TwitterShareButton,
  // FacebookMessengerShareButton,
  EmailIcon,
  TwitterIcon,
  // PinterestIcon,
  RedditIcon,
  FacebookIcon,
  // FacebookMessengerIcon,
  // FacebookShareCount,
  // PinterestShareCount,
  // RedditShareCount,
} from 'react-share'
import {
  QuizStoreContext,
  QuizDispatchContext,
} from '../../contexts/quizContext'
import { category_info, isHiddenCategory } from '../../data/features'
import { hashtag } from '../../utils/constants'
import { convertFeatureToTitle } from '../../utils/functions'
import { R, summaryText, T } from '../../utils/Typography'

const ShareBox = () => {
  const shareUrl = window.location.href.split('?')[0]
  const { quizResults } = React.useContext(QuizStoreContext)
  // const firstFeatureName = convertFeatureToTitle(podcastTone).split(':')[1]
  // const secondFeatureName = convertFeatureToTitle(publishingSchedule).split(
  //   ':',
  // )[1]
  // const firstFeatureCategory = convertFeatureToTitle(podcastTone)
  //   .split(':')[0]
  //   .toLowerCase()
  // const secondFeatureCategory = convertFeatureToTitle(publishingSchedule)
  //   .split(':')[0]
  //   .toLowerCase()
  // const realismName = convertFeatureToTitle(hostingStyle).split(':')[1]
  // const artTheoryName = convertFeatureToTitle(podcastGenre).split(':')[1]
  const title = `This quiz helped me identify the style for my podcast! ${hashtag}`
  const body = Object.entries(quizResults)
    .filter(([category]) => !isHiddenCategory(category_info[category]))
    .reduce(
      (accu, [category, feature]) => [
        ...accu,
        summaryText({ category, feature }),
      ],
      [] as string[],
    )
    .join('\n')

  return (
    <div className='Sharebox_container'>
      <T style={{ fontSize: '1rem', textAlign: 'center', marginBottom: 5 }}>
        Share your podcast style with {hashtag}!
      </T>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <FacebookShareButton url={shareUrl} quote={title + '\n' + body + '\n'}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <div style={{ width: 10 }} />
        <TwitterShareButton url={shareUrl} title={title + '\n' + body + '\n'}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <div style={{ width: 10 }} />
        {/* <PinterestShareButton url={shareUrl} media={`${shareUrl}/${anger_img}`} >
                    <PinterestIcon size={32} round />
                </PinterestShareButton> */}
        <RedditShareButton
          url={shareUrl}
          title={title}
          windowWidth={660}
          windowHeight={460}>
          <RedditIcon size={32} round />
        </RedditShareButton>
        <div style={{ width: 10 }} />
        <EmailShareButton url={shareUrl} subject={title} body={body + '\n\n'}>
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </div>
  )
}

export default ShareBox
